import { t } from 'i18next';
import ClinicsManagement from '../views/management/ClinicsManagement';
import ClinicSettings from '../views/management/ClinicSettings';
import ClinicUsersManagement from '../views/management/ClinicUsersManagement';
import CreateClinic from '../views/management/CreateClinic';
import CreateClinicUser from '../views/management/CreateClinicUser';
import ManagementDashboard from '../views/management/ManagementDashboard';
import Settings from '../views/pages/settings';
import Profile from '../views/pages/Profile';
import EditClinicUser from "../views/management/EditClinicUser";

// ===========================|| MAIN ROUTING ||=========================== //

// Role-based main routes
const getAdminRoutes = (role) => {
    switch (role) {
        case 'BCK_ADMIN':
            return [
                {
                    path: '/',
                    element: <ManagementDashboard />
                },
                {
                    path: '/settings',
                    element: <Settings />
                },
                {
                    path: '/profile',
                    name: t('routes.plan_details'),
                    element: <Profile />
                },
                {
                    path: '/mgmt',
                    name: t('routes.mgmt'),
                    element: <ManagementDashboard />
                },
                {
                    path: '/mgmt/clinics',
                    name: t('routes.clinics'),
                    element: <ClinicsManagement />
                },
                {
                    path: '/mgmt/clinics/create',
                    name: t('routes.createClinic'),
                    element: <CreateClinic />
                },
                {
                    path: '/mgmt/clinic/users',
                    name: t('routes.clinicUsers'),
                    element: <ClinicUsersManagement />
                },
                {
                    path: '/mgmt/clinic/users/create',
                    name: t('routes.create_user'),
                    element: <CreateClinicUser />
                },
                {
                    path: '/mgmt/clinic/users/edit',
                    name: t('routes.edit_user'),
                    element: <EditClinicUser />
                },
                {
                    path: '/mgmt/clinic/settings',
                    name: t('routes.clinicSettings'),
                    element: <ClinicSettings />
                }
            ];
        default:
            return [];
    }
};

const getNameByRoute = (routes, path) => {
    for (const route of routes) {
        if (route.path === path) {
            return route?.name;
        }
        if (route.children) {
            const childRoute = getRouteByPath(route.children, path);
            if (childRoute) {
                return childRoute;
            }
        }
    }
    return null;
};

export const getRouteByPath = (path) => {
    return getNameByRoute(getAdminRoutes('BCK_ADMIN'), path);
};

export default getAdminRoutes;
